export default __webpack_public_path__ + "static/media/logo--manning-publications.784ec4ec.svg";